import { Navbar, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function TitleBar() {
    if (window.location !== window.parent.location) {
        return <></>;
    }
    return (
        <Navbar
            expand="sm"
            style={{
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'rgba(255,255,255,0.12)',
                backgroundColor: 'var(--wpa-dark-blue)',
                paddingTop: '10px',
                paddingBottom: '10px',
            }}
        >
            <Link to='/'>
                <Image
                    className="mx-2"
                    src={`${process.env.PUBLIC_URL}/wpa_logo_alpha.png`}
                    height={46}
                />
            </Link>
        </Navbar>        
    );
}
